import React, { Component } from 'react';
import { connect } from 'react-redux';

import { LogoSize } from '../../store/slices/customization/customization';
import cssVariables from '../../../src/sxVariablesExported.module.scss';

const SIGHTX_LIGHTER_GRAY = '#d9d9d9';
const SX_GRAY_CONCEPT = '#f5f5f5';

class SurveyStyle extends Component {
  render() {
    const {
      foregroundColor,
      backgroundColor,
      backgroundImage = {},
      question = {},
      showTitle,
      logo,
      answer = {},
      showConceptTest,
    } = this.props;
    const { align = 'center' } = answer;
    const backgroundImageExists = backgroundImage && backgroundImage.url;
    const headerDisplay = showTitle === true ? '' : 'display: none !important;';
    const headerBorder = showTitle === true ? '' : 'border: 0px !important;';

    const logoSize = (function (logo) {
      let size = `max-height: ${cssVariables.logoHeightSmall};`;
      if (logo && logo.size !== undefined) {
        switch (logo.size) {
          case LogoSize.large:
            size = `max-height: ${cssVariables.logoHeightLarge};`;
            break;
          case LogoSize.medium:
            size = `max-height: ${cssVariables.logoHeightMedium};`;
            break;
        }
      }
      size += 'max-width: 100%;';
      return size;
    })(logo);

    const logoBackgroundColor =
      logo && logo.color !== undefined && !backgroundImage.url ? `background-color: ${logo.color};` : '';

    const justifyContentControls = align === 'center' ? align : align === 'left' ? 'flex-start' : 'flex-end';

    const hidePreviewTools = showConceptTest ? '.preview-controls { display: none; }' : '';
    const surveyHeader =
      backgroundColor & !backgroundImage.url
        ? `.surveyContainer .survey-header {background-color: ${backgroundColor};}`
        : '';

    const { align: questionAlignment = 'left', color: questionColor, font: questionFont } = question;
    const common = `
      .submitMessage {
        color: ${questionColor};
        font-family: ${questionFont};
        text-align: ${questionAlignment};
      }
      .customize-content { background-color: ${backgroundColor}; }
      .survey-body .ui.card.survey { margin: 0; }
      .question-content { z-index: ${showConceptTest ? '106' : '1'}; }
      .submit .ui.teal.button {
        background-color: ${foregroundColor};
      }
      .header-image {
        ${logoSize}
      }
      ${hidePreviewTools}
      .surveyContainer .logo-main-container .logo-container {
        ${logoBackgroundColor}
        line-height: 0;
      }
      .surveyContainer .survey-header .survey {
        ${logoBackgroundColor}
      }
      .surveyContainer .survey-header .survey {
        ${headerBorder}
      }
      .survey-header .survey .header {
        ${headerDisplay}
      }
      ${surveyHeader}
      .capture { background-color: ${backgroundColor}; }
      .fullscreen { background-color: ${backgroundColor}; }
      .survey .header .header-title {
        color: ${questionColor};
        font-family: ${questionFont};
        ${headerDisplay}
      }
      .question-content .input.number .ui.collapsing.table {
        margin: 0;
      }
      
      .question-content .table-card.grid.none {
        background-image:
          /* Shadows */
          linear-gradient(to right, ${backgroundColor}, ${backgroundColor}),
          linear-gradient(to right, ${backgroundColor}, ${backgroundColor}),
          /* Shadow covers */
          linear-gradient(to right, rgba(0,0,0,.15), rgba(255,255,255,0)),
          linear-gradient(to left, rgba(0,0,0,.15), rgba(255,255,255,0));

        background-position: left center, right center, left center, right center;
        background-repeat: no-repeat;
        background-color: ${backgroundColor};
        background-size: 20px 100%, 20px 100%, 10px 100%, 10px 100%;

        /* Opera doesn't support this in the shorthand */
        background-attachment: local, local, scroll, scroll;
      }

      .question-content .input.number,
      .question-content .table-card.grid.max-diff,
      .question-content .table-card.grid.max-diff-experiment,
      .question-content .ui.grid.dateQuestionGrid,
      .question-content .table-card.grid.nps {
        display: flex;
        justify-content: ${justifyContentControls};
      }

      .question-content .constantSumQuestion {
        align-items: ${justifyContentControls};
      }

      .question-content .ui.selection.dropdown {
        background: ${backgroundColor};
      }
      
      .customize-content > .fullscreen .surveyContainer > .survey-body {
        position: relative;
        top: 63px;
      }
    
      .common-checkbox {
        &.ant-checkbox-wrapper {
          &.ant-checkbox-wrapper-disabled {
            .ant-checkbox-checked {
              .ant-checkbox-inner {
                background-color: ${SX_GRAY_CONCEPT};
                border-color: ${foregroundColor};
              }
            }
          }
          &:hover {
            .ant-checkbox-inner {
              border-color: ${SIGHTX_LIGHTER_GRAY};
            }
          }
          .ant-checkbox-checked {
            .ant-checkbox-inner {
              background-color: ${foregroundColor};
              border-color: ${foregroundColor};
            }
            &::after {
              border-color: ${foregroundColor};
            }
          }
          .ant-checkbox {
            &:hover {
              .ant-checkbox-inner {
                border-color: ${SIGHTX_LIGHTER_GRAY};
              }
            }
            &:focus,
            &:active {
              .ant-checkbox-inner {
                border-color: ${foregroundColor};
              }
            }
            .ant-checkbox-input:focus + .ant-checkbox-inner {
              border-color: ${foregroundColor};
            }
          }
        }
      }
      
      .sx-check,
      a.left.arrow.navigation i,
      a.left.chevron.navigation i {
        color: ${foregroundColor};
      }
      .na-survey-label:focus{
        outline: solid 1px ${foregroundColor};
      }
      p {
        font-size: inherit;
        line-height: inherit;
        line-height: 1.5;
      }
      a.right.arrow.navigation,
      a.right.chevron.navigation {
        background-color: ${foregroundColor};
      }
      a.left.text-arrow.navigation{
        color: ${foregroundColor};
      }
      a#nextPageId{
          background-color: ${foregroundColor};
      }`;
    if (backgroundImageExists) {
      const backgroundClass = backgroundImage.tiled ? '' : '.background-container';
      const cover = backgroundImage.tiled
        ? 'background-size: auto !important;'
        : 'background-size: cover !important;  background-attachment: fixed !important; background-repeat: no-repeat !important;';
      const positionAndHeight = backgroundImage.tiled ? 'height: auto; min-height: 100% !important;' : '';
      const opacity = backgroundImage.opacity >= 0 ? `${(100 - backgroundImage.opacity) / 100}` : '';
      const backgroundContainerStyles = `
        background: linear-gradient(rgba(255, 255, 255, ${opacity}), rgba(255, 255, 255, ${opacity})), url(${backgroundImage.url}) !important;
        ${positionAndHeight}
        width: 100%;
        ${cover}
        background-position: center top !important;
      `;

      return (
        <style type="text/css" scoped>
          {`
            .customize-content > .customize .surveyContainer${backgroundClass} {
              ${backgroundContainerStyles}
              position: absolute;
              width: calc(100vw - 470px);
            }
            .customize-content > .fullscreen .surveyContainer${backgroundClass} {
              ${backgroundContainerStyles}
            }
            .capture > .surveyContainer${backgroundClass} {
              ${backgroundContainerStyles}
              position: unset;
            }
            ${common}
          `}
        </style>
      );
    }

    return (
      <style type="text/css" scoped>
        {`
          ${common}
        `}
      </style>
    );
  }
}

const mapStateToProps = (state) => {
  const { customization, activeProject: { survey: { showConceptTest } = {} } = {} } = state;

  return {
    foregroundColor: customization.foregroundColor,
    backgroundColor: customization.backgroundColor,
    backgroundImage: customization.backgroundImage,
    question: customization.question,
    showTitle: customization.showTitle,
    logo: customization.logo,
    answer: customization.answer,
    showConceptTest,
  };
};

export default connect(mapStateToProps)(SurveyStyle);
